import { useQuery } from '@tanstack/react-query'
import { business, inboundRouter } from '@chilipiper/service'
import { defaultErrorCallback } from '@chilipiper/service/src/api'
import { useEffect } from 'react'

export const useGuestRoute = (routerName: string, domain: string) => {
  const { data: organizationName, error } = useQuery({
    queryKey: ['OrganizationName', domain],
    queryFn: () => business.domain.getOrganizationName(domain),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  })

  const {
    data: routeSettings,
    isLoading: isLoadingRouteSettings,
    error: routeSettingsError,
  } = useQuery({
    queryKey: ['inboundRouterByLink', routerName, domain],
    queryFn: () => inboundRouter.getInboundRouterByLink(domain, routerName),

    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    if (routeSettingsError) {
      defaultErrorCallback(routeSettingsError as any)
      // When this request fails, we flood the BE with other requests
      window.location.href = `${window.location.origin}/book/not-available`
    }
  }, [routeSettingsError])

  useEffect(() => {
    if (error) {
      defaultErrorCallback(error as any)
    }
  }, [error])

  return {
    organizationName,
    routeSettings,
    isLoadingRouteSettings,
  }
}
